import React from 'react';

import type { IVisibilityObserverProps } from './VisibilityObserver.typings';

export const VisibilityObserver: React.FC<IVisibilityObserverProps> = ({ onVisible, onHide }) => {
    const ref = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        const el = ref.current;

        if (!el) return;

        const observer = new IntersectionObserver(entries => {
            (entries[0].isIntersecting ? onVisible : onHide)?.();
        });

        observer.observe(el);

        return () => observer.disconnect();
    }, [ref, onVisible, onHide]);

    return (
        <div ref={ref} />
    );
};
